module.exports = __webpack_public_path__ + "static/media/order_placed.a0ed99c2.png";